/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

type CSVContent = (string | number)[][];
export class Downloader {

    getEmptyCSV(): CSVContent {
        return [];
    }

    downloadCSV(fileName: string, content: CSVContent, seperator = ',') {
        let csvContent = '';
        content.forEach((row) => {
            row.forEach((value, idx) => {
                if ((typeof value === 'string')) {
                    if (value.includes(seperator) || value.includes(' ') || value.includes('"') || value.includes('\n')) {
                        csvContent += '"' + value.replace(/"/g, '""') + '"' ;
                    } else {
                        csvContent += value;
                    }
                } else if (typeof value === 'number') {
                    csvContent += value.toString();
                } else if (value === null || value === undefined) {
                    csvContent += '';
                } else {
                    csvContent += value + ' - Not a number or string';
                }
                if (idx < row.length - 1) {
                    csvContent += seperator;
                }
            })
            csvContent += '\n';
        });
        this.download(fileName, 'csv', csvContent);
    }

    download(fileName: string, fileType: string, content: string) {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/' + fileType + ';charset=UTF-8,' + encodeURIComponent(content));
        element.setAttribute('download', fileName + '.' + fileType);
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click(); // simulate click
        document.body.removeChild(element);
    }

}
